import {ForecastRevision} from './forecast-revision';

export class ForecastRevisionCollection {
    private totalItems: number = 0;
    private forecastRevisions: ForecastRevision[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setForecastRevisions(forecastRevisions: ForecastRevision[]) {
        this.forecastRevisions = forecastRevisions;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getForecastRevisions(): ForecastRevision[] {
        return this.forecastRevisions;
    }
}
